import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {forceToggles, toggle} from 'opticks'

import {getUser, selectIsHoldoutGroup} from '../modules/selectors'
import {updateHoldoutGroup} from '../modules/thunks'

export const SyncHoldoutGroup = () => {
  const user = useSelector(getUser)
  const isHoldoutGroup = useSelector(selectIsHoldoutGroup)

  const dispatch = useDispatch()
  useEffect(() => {
    if (!user) return

    // If user was allocated once to in the holdout group, force the toggle to be A side
    if (isHoldoutGroup) {
      forceToggles({'0b9c26e4-holdout-group': false})
    }

    // If user was allocated once out of the holdout group, force the toggle to be B side
    if (isHoldoutGroup === false) {
      forceToggles({'0b9c26e4-holdout-group': true})
    }
  })

  useEffect(() => {
    if (!user) return

    console.log(
      '0b9c26e4-holdout-group - isHoldoutGroup',
      toggle('0b9c26e4-holdout-group', true, false)
    )

    if (isHoldoutGroup === undefined) {
      dispatch(updateHoldoutGroup())
    }
  })

  return null
}
